export default {
  "welcome": {
    "welcome-to": "欢迎来到",
    "one-philly": "一个费城，",
    "united-city": "一个统一的城市！",
  },
  "city-offices": {
    "city-offices-title": "城市办公室",
    "city-offices-text-1": "市政办公室按正常工作时间开放。有些服务是在线或预约提供的。要了解更多信息， ",
    "city-offices-text-2": "请向您的感兴趣部门查询。",
    "city-offices-closure-text": "",
    "trash-title": "垃圾和回收利用",
    "trash-text-1": "垃圾和回收物品的收集是按假日安排的。比平时晚一天准备好材料。",
    "trash-text-2": "要了解更多信息，",
    "trash-text-3": "查看假期时间表。",
    "trash-closure-text": "",
  },
  "services": {
    "trash": "找回你的垃圾日",
    "bill": "支付账单",
    "jobs": "探索城市职位",
    "property": "搜索房产",
    "taxes": "申报并缴纳城市税",
    "recycle": "回收秋叶",
    "visit": "探视被监禁的人",
    "license": "获得许可证",
    "popular-services": "热门服务",
    "jump-to-all-services": "跳转到所有服务",
    "services-by-topic": "按主题划分的服务",
    "see-all-services": "查看所有服务",
  },
  "tools": {
    "parks-finder": "公园和娱乐场所",
    "contracts": "合同中心",
    "school-time-activity": "课外活动查找器",
    "food-meal": "免费食物和膳食查找器",
    "atlas": "地图集",
    "primary": "初级保健查找器",
    "eclipse": "日食",
    "mail-vote-remind": "邮寄投票提醒",
    "street-smart": "x",
    "commonly-used-tools": "常用工具",
    "see-all-tools": "查看所有工具",
  },
  "news": {
    "featured-news": "精选新闻",
    "see-all-news": "查看所有新闻",
  },
  "311": {
    "report-311": "帮助费城成为全美最安全、最清洁、最绿色的大城市。向 Philly311 举报空地、涂鸦、废弃汽车等。",
    "report-problem": "报告问题",
    "track-request": "追踪请求",
    "ask-question": "问一个问题",
  },
  "stay-connected": {
    "stay-connected": "保持联系",
    "sign-up-email": "注册接收来自费城市的电子邮件更新",
    "sign-up": "注册吧",
  },
  "footer": {
    "elected-officials": "民选官员",
    "mayor": "市长",
    "city-council": "市议会",
    "courts": "法院",
    "district-attorney": "地区检察官",
    "city-controller": "城市主管",
    "sheriff": "郡治安官",
    "city-commissioners": "城市专员",
    "register-wills": "遗嘱登记册",
    "open-govt": "开放政府",
    "code-charter": "费城守则和章程",
    "city-records": "城市记录",
    "city-agency-regs": "城市机构条例",
    "executive-orders": "行政命令",
    "honesty-govt": "政府的诚信",
    "voting-elections": "投票和选举",
    "open-data": "打开数据",
    "org-chart": "城市组织结构图",
    "explore-phila": "探索费城",
    "visit-phila": "参观费城",
  },
  "clean-green": {
    "clean-green": "干净又环保 ",
    "clean-green-statement": "我们的城市正在团结起来，使费城成为全美最安全、最清洁、最环保的大城市，为所有人提供经济机会。遵循解决每个社区生活质量问题的全市战略。",
    "blocks-swept": "方块横扫了",
    "abandoned-autos": "废弃的汽车已移除",
    "properties-cleaned": "物业已清洁并密封",
    "graffiti-removed": "涂鸦已移除",
    "see-all-clean-green": "查看所有清潔和綠色產品",
  },
  "mayor": {
    "mayor-details": "谢雷尔·帕克是费城第100任市长，也是341年来首位担任该职位的女性。作为这座城市的终身居民，她致力于每天为费城人而战。",
    "learn-more": "了解更多",
  },
  "city-council": {
    "city-council": "市议会",
    "district-council-member": "区议会议员",
    "council-member-al":  "理事会普通会员",
    "council-president": "理事会主席",
    "dep-majority-whip": "副多数党鞭子",
    "majority-whip": "多数党鞭子",
    "minority-leader": "少数党领袖",
    "minority-whip": "少数派鞭子",
    "majority-leader": "多数党领袖",
  }, 
  "philly-stat-360": {
    "ps360": "费城星报 360",
    "data-subheader": "将数据转化为我们社区的行动。",
  },
};